module.exports = __webpack_public_path__ + "static/amilas-6761efbf9f029f797c300782a65aa719.png";